import { TenDlcDetails } from './_types';

export const hasStarted10Dlc = (details: TenDlcDetails): boolean => {
  return !!details?.twilio10dlcStatus;
};

export const isAwaiting10DlcBrandApproval = (
  details: TenDlcDetails
): boolean => {
  return details.twilio10dlcStatus === 'awaiting_brand_approval';
};

export const isAwaiting10DlcCampaignApproval = (
  details: TenDlcDetails
): boolean => {
  return details.twilio10dlcStatus === 'awaiting_campaign_approval';
};

export const isAwaiting10DlcNumberApproval = (
  details: TenDlcDetails
): boolean => {
  return details.twilio10dlcStatus === 'awaiting_phone_number_approval';
};

export const is10DLCApproved = (details: TenDlcDetails): boolean => {
  return details.twilio10dlcStatus === 'approved';
};
